import { request } from './auth-actions'
import newsServiceApi from '../../api/news-service-api'
import { genericError } from './action-utils'
import { CLEAR_NEWS_ARTICLE, GET_NEWS_ARTICLE_SUCCESS } from './action-types'

const getNewsArticleSuccess = response => ({
  type: GET_NEWS_ARTICLE_SUCCESS,
  response,
})

const clearNewsArticle = () => ({
  type: CLEAR_NEWS_ARTICLE,
})

export const getNewsArticleAndStores = articleId => dispatch => {
  dispatch(clearNewsArticle())
  return dispatch(request(newsServiceApi.getArticle, articleId))
    .then(articleData => dispatch(getNewsArticleSuccess(articleData)))
    .catch(error => {
      genericError(error)
      throw error
    })
}
